import config from "../config"
const baseUrl = config.base_url + "z_agricultural_store_manager/"
export default {
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    }
}
